import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(theme=>({
    textField: {
        width:'100% !important',
        margin:' 1.2rem 0px !important',
    }
}))
export default useStyles;